import { useState } from "react";
import { api } from "../lib/api";
import { toast } from "sonner";
import { Loader2, Eye, EyeOff, KeyRound } from "lucide-react";

const rules = (pw) => [
  ["Almeno 10 caratteri", pw.length >= 10], ["Una maiuscola", /[A-Z]/.test(pw)], ["Una minuscola", /[a-z]/.test(pw)],
  ["Un numero", /\d/.test(pw)], ["Un simbolo", /[^A-Za-z0-9]/.test(pw)],
];

export function AccountSettings({ email }) {
  const [cur, setCur] = useState(""); const [pw, setPw] = useState(""); const [pw2, setPw2] = useState("");
  const [show, setShow] = useState(false); const [busy, setBusy] = useState(false);
  const checks = rules(pw);
  const ok = checks.every(([, v]) => v) && pw === pw2 && cur;

  const submit = async (e) => {
    e.preventDefault(); setBusy(true);
    try {
      await api.post("/auth/change-password", { current_password: cur, new_password: pw });
      toast.success("Password aggiornata. Usala al prossimo accesso."); setCur(""); setPw(""); setPw2("");
    } catch (err) { toast.error(typeof err.response?.data?.detail === "string" ? err.response.data.detail : "Errore nel cambio password"); }
    setBusy(false);
  };

  return (
    <form data-testid="account-settings" onSubmit={submit} className="bg-white border border-border rounded-2xl p-6 space-y-4 max-w-2xl">
      <div className="flex items-center gap-3"><KeyRound size={18} strokeWidth={1.5} /><h3 className="font-serif text-2xl">Account amministratore</h3></div>
      <div className="text-sm"><span className="text-ink-soft">E-mail di accesso:</span> <span data-testid="account-email" className="font-medium">{email}</span></div>
      {[["Password attuale", cur, setCur, "current"], ["Nuova password", pw, setPw, "new"], ["Conferma nuova password", pw2, setPw2, "confirm"]].map(([label, val, set, id]) => (
        <label key={id} className="block">
          <span className="text-xs uppercase tracking-wider text-ink-soft">{label}</span>
          <div className="relative mt-1.5">
            <input data-testid={`pw-${id}`} type={show ? "text" : "password"} value={val} onChange={(e) => set(e.target.value)} autoComplete={id === "current" ? "current-password" : "new-password"}
              className="w-full h-11 px-3 pr-11 rounded-xl border border-border outline-none focus:border-ink" />
            <button type="button" onClick={() => setShow(!show)} aria-label="Mostra password" className="absolute right-3 top-1/2 -translate-y-1/2 text-ink-soft">{show ? <EyeOff size={16} /> : <Eye size={16} />}</button>
          </div>
        </label>
      ))}
      <ul className="grid grid-cols-2 gap-1 text-xs">
        {checks.map(([l, v]) => <li key={l} className={v ? "text-forest" : "text-ink-soft"}>{v ? "✓" : "○"} {l}</li>)}
        <li className={pw && pw === pw2 ? "text-forest" : "text-ink-soft"}>{pw && pw === pw2 ? "✓" : "○"} Le password coincidono</li>
      </ul>
      <button data-testid="pw-submit" disabled={!ok || busy} className="px-6 py-3 rounded-full bg-ink text-white text-sm hover:opacity-90 disabled:opacity-40">
        {busy ? <Loader2 size={14} className="animate-spin" /> : "Aggiorna password"}
      </button>
    </form>
  );
}
